module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_15.620dd330.jpg";